// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"e7858efdf495c7e23618","883":"f48b76cb1aab6fcfdc5d"}[chunkId] + ".js";
};